/**
 * Simplified Auth Hook - Provides auth state from Zustand store
 */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { useCallback } from 'react';
import { resetPostHogUser } from '@workspace/analytics/posthog/client';
import { resetSentryUser } from '@workspace/analytics/sentry/user';
import { fetchWithIdempotency } from '@workspace/request-idempotency';
import { useAuthStore } from '@/stores/authStore';

export function useAuth() {
  const { isAuthenticated, accessToken, user, isLoading } = useAuthStore();

  /**
   * Logout function that calls API directly and redirects
   */
  const logout = useCallback(async () => {
    try {
      // Call logout API to clear server-side cookies
      await fetchWithIdempotency('/api/auth/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
    } catch (error) {
      console.warn('Logout API call failed:', error);
    } finally {
      // Always clear client state regardless of API call success
      resetPostHogUser();
      resetSentryUser();
      useAuthStore.getState().setAccessToken(null);
      useAuthStore.getState().setAuthenticated(false);
      useAuthStore.getState().setUser(null);

      // Redirect to auth app
      window.location.href = process.env.NEXT_PUBLIC_FE_URL_AUTH || '/login';
    }
  }, []);

  return {
    // Current auth state from Zustand store
    user,
    accessToken,
    isAuthenticated,
    isLoading,

    // Actions
    logout,
  };
}
